import axiosInstance from "./axiosInstance";

export const getCustomerLottery = (params) => {
  const queryParams = { ...params };
  if (!queryParams.site) {
    queryParams.site = process.env.REACT_APP_SITE_ID;
  }
  return axiosInstance.get("/customer-lottery", { params: queryParams });
};

export const updateCustomerLotteryStatus = (id) => {
  return axiosInstance.patch(`/customer-lottery/update-status/${id}`);
};

export const getCustomerLotteryDetail = (id) => {
  return axiosInstance.get(`/customer-lottery/customer-detail/${id}`);
};

// Export Excel for RewardCode
export const exportCustomerLotteryExcel = async (site) => {
  return axiosInstance.post(
    `customer-lottery/download-data?site=${encodeURIComponent(site)}`,
    {},
    { responseType: "blob" }
  );
};
